import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=6264d895&"
import script from "./HomeMain.vue?vue&type=script&lang=js&"
export * from "./HomeMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports